module.exports = __webpack_public_path__ + "static/img/DeviceCheckNoteTw.1291935.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DeviceCheckNoteTw.png
// module id = q8KX
// module chunks = 1